import request from '@/utils/request'
// 企业管理 - 列表
export const getCompanyList = (params: any) =>
  request({
    url: 'admin/company/list',
    method: 'get',
    params
  })
// 企业管理 - 新增
export const addCompany = (params: any) =>
  request({
    url: '/admin/company/add',
    method: 'post',
    params
  })
// 企业管理 - 修改
export const putCompany = (params: any) =>
  request({
    url: `/admin/company/put/${params.id}`,
    method: 'put',
    params
  })
// 企业管理 - 删除
export const delCompany = (params: any) =>
  request({
    url: `/admin/company/del/${params.id}`,
    method: 'delete',
    params
  })
// 库房管理 - 列表
export const getStorehouseList = (params: any) =>
  request({
    url: `admin/storehouse/list`,
    method: 'get',
    params
  })
// 库房管理 - 新增
export const addStorehouse = (params: any) =>
  request({
    url: `admin/storehouse/add`,
    method: 'post',
    params
  })
// 库房管理 - 修改
export const putStorehouse = (params: any) =>
  request({
    url: `admin/storehouse/put/${params.id}`,
    method: 'put',
    params
  })
// 库房管理 - 删除
export const delStorehouseList = (params: any) =>
  request({
    url: `admin/storehouse/del/${params.id}`,
    method: 'delete',
    params
  })
// 库房管理 - 清空
export const clearStorehouse = (params: any) =>
  request({
    url: `admin/storehouse/cls/${params.id}`,
    method: 'put',
    params
  })
// 主机管理 - 列表
export const getHostList = (params: any) =>
  request({
    url: 'admin/host/list',
    method: 'get',
    params
  })
// 主机管理 - 新增
export const addHost = (params: any) =>
  request({
    url: 'admin/host/add',
    method: 'post',
    params
  })
// 主机管理 - 修改
export const putHost = (params: any) =>
  request({
    url: 'admin/host/put',
    method: 'put',
    params
  })
// 主机管理 - 删除
export const delHost = (params: any) =>
  request({
    url: `admin/host/del/${params.id}`,
    method: 'delete',
    params
  })
// 主机管理 - 停用
export const stopHost = (params: any) =>
  request({
    url: `/admin/host/stop/${params.id}`,
    method: 'put',
    params
  })
// 主机管理 - 重启
export const restartHost = (params: any) =>
  request({
    url: `/admin/host/restart/${params.id}`,
    method: 'put',
    params
  })
// 仪表管理 -列表
export const getMeterList = (params: any) =>
  request({
    url: 'admin/meter/list',
    method: 'get',
    params
  })
// 仪表管理 -新增
export const addMeter = (params: any) =>
  request({
    url: 'admin/meter/add',
    method: 'post',
    params
  })
// 仪表管理 -修改
export const putMeter = (params: any) =>
  request({
    url: `admin/meter/put/${params.id}`,
    method: 'put',
    params
  })
// 仪表管理 -删除
export const delMeter = (params: any) =>
  request({
    url: `admin/meter/del/${params.id}`,
    method: 'delete',
    params
  })
